export const loaderHolder = {
    display:'flex',
    justifyContent:'center',
    alignItems:'center'
}

export const definedComponent = {

}